var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0563 1.86577C19.548 1.29527 18.9279 0.835297 18.2344 0.514374C17.541 0.19345 16.789 0.0184211 16.0251 0.000141474C15.2619 -0.016588 14.5031 0.120928 13.7943 0.40445C13.0855 0.687973 12.4412 1.11167 11.9001 1.65014L11.0001 2.54077L10.297 1.84702C8.11258 -0.346733 4.55008 -0.534233 2.3657 1.44389C1.79723 1.95387 1.33874 2.57443 1.01829 3.26765C0.697834 3.96087 0.522144 4.71216 0.501962 5.47559C0.481779 6.23903 0.617527 6.99856 0.900906 7.70774C1.18429 8.41692 1.60934 9.06084 2.15008 9.60014L9.9407 17.3908C10.0793 17.5308 10.2443 17.6419 10.4261 17.7178C10.608 17.7937 10.8031 17.8327 11.0001 17.8327C11.1971 17.8327 11.3922 17.7937 11.574 17.7178C11.7558 17.6419 11.9208 17.5308 12.0595 17.3908L19.6532 9.79702C21.847 7.61264 22.0251 4.05014 20.0563 1.86577Z",
    fill: "#1650FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4adeaa5ebd2e2aa077554977871e87b1.svg";
export { ForwardRef as ReactComponent };